// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"127":"365b3ada","281":"0b7afab5","313":"895b99b2","326":"016f2636","333":"d51eb4c3","611":"8a840a38","727":"64067006","758":"a153faf2","893":"5089b79d","998":"5e2b3624"}[chunkId] + ".chunk.js";
};